import React from "react"
import styled from "@emotion/styled"

const PricingWrapper = styled.div`
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
`
const PricingCard = styled.div`
    display: flex;
    flex-direction: column;
    width: 250px;
    height: 250px;
    border-radius: 1.5rem;
    margin-top: 1rem;
    padding: 1rem;
`
const Title = styled.p`
    color: ${(props) => props.theme.colors.secondary} !important;
    font-weight: bold !important;
    font-size: 1.2rem;
    word-break: break-word;
    text-align: left;
    margin-top: 0;
`
const Price = styled.div`
    text-align: left;
    display: flex;
    flex-direction: column;
    margin-top: auto;
    color: #333333;

    & .price-tag {
        color: #510291;
        font-weight: bold;
        & .currency {
            font-size: 28px;
            margin-right: 1rem;
            vertical-align: top;
        }
        & .price {
            font-size: 56px;
        }
    }
    & .unit {
        color: ${(props) => props.theme.colors.text1};
        font-size: 20px;
    }
`
const Index = ({ data }) => {
    return (
        <PricingWrapper>
            {data.length &&
                data.map((el, idx) => {
                    return (
                        <PricingCard key={idx}>
                            <Title>{el.label}</Title>
                            <Price>
                                from
                                <div className="price-tag">
                                    <span className="currency">$</span>
                                    <span className="price">{el.price}</span>
                                </div>
                                <span className="unit"> / {el.unit}</span>
                            </Price>
                        </PricingCard>
                    )
                })}
        </PricingWrapper>
    )
}
export default Index
